import { AuditRequirementResponse, Status } from '@shared/types'

export type StatusText = { auditor: string; client: string }

export const getStatusText = (
  statuses: Status[],
  requirement: AuditRequirementResponse
): StatusText => {
  const auditor =
    statuses.find(
      (status) => status.statusID === requirement?.auditorStatus?.statusBaseId
    )?.name ?? '-'

  const client =
    statuses.find(
      (status) => status.statusID === requirement?.clientStatus?.statusBaseId
    )?.name ?? '-'

  return {
    auditor,
    client,
  }
}
